"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roleAssignmentFactory = void 0;
const Factory = require("factory.ts");
exports.roleAssignmentFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    resource_type: 'Organization',
    resource_id: '530',
    resource_system: null,
    principal_type: 'Persona',
    principal_id: 1,
    principal_system: null,
    role: 'org_admin',
    org_id: 530,
    filters: [],
    friendly_name: 'Org Admin',
    role_type: 'CompositeRole',
    role_id: 5,
    role_key: 'orgAdmin',
    uri: Factory.each(i => `https://user.sportngin.com.dev/role_assignments/${i + 1}`),
});
